import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiMail, FiRefreshCw, FiTruck, FiUsers } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const serviceItems = [
    { icon: FiTruck, title: "QUICK SHIPPING", copy: "Delivered with care to supported destinations." },
    { icon: FiRefreshCw, title: "SEAMLESS RETURNS", copy: "A considered, effortless process." },
    { icon: FiMail, title: "EMAIL SUPPORT", copy: "Personal assistance during service hours." },
    { icon: FiUsers, title: "PLANNER COMMUNITY", copy: "Intentional, connected, growing." },
  ];

  return (
    <footer className="site-footer" role="contentinfo">
      <section className="footer-services" aria-label="Service promises">
        {serviceItems.map(({ icon: Icon, title, copy }) => (
          <article key={title}>
            <Icon aria-hidden="true" />
            <div>
              <h2>{title}</h2>
              <p>{copy}</p>
            </div>
          </article>
        ))}
      </section>

      <section className="footer-feature">
        <div>
          <p className="eyebrow">CEOWANDMILL</p>
          <h2>MAKE SPACE FOR WHAT MATTERS.</h2>
          <p>
            Thoughtful planning tools, tactile materials, and calm systems for
            days that deserve a little more clarity.
          </p>
        </div>
        <Link className="footer-care-link" to="/about" onClick={toTop}>DISCOVER OUR APPROACH <FiArrowRight /></Link>
      </section>

      <section className="footer-main">
        <div className="footer-brand">
          <Link to="/" onClick={toTop}>
            {siteConfig.logo?.text || siteConfig.brandName}
          </Link>
          <p>{siteConfig.description}</p>
          <address aria-label="Customer care email and business location">
            <a href={`mailto:${siteConfig.contact?.email}`}>
              {siteConfig.contact?.email}
            </a>
            <span>{siteConfig.contact?.address}</span>
          </address>
        </div>

        <nav aria-label="Shop footer links">
          <h2>SHOP</h2>
          <Link to="/shop?tag=planner-system" onClick={toTop}>Start Planning</Link>
          <Link to="/shop?collection=new" onClick={toTop}>New Arrivals</Link>
          <Link to="/shop?category=Planners" onClick={toTop}>Planner Systems</Link>
          <Link to="/shop?category=Planner+Inserts" onClick={toTop}>Planner Inserts</Link>
          <Link to="/shop?tag=best-seller" onClick={toTop}>Best Sellers</Link>
          <Link to="/shop" onClick={toTop}>Shop All</Link>
        </nav>

        <nav aria-label="Customer service footer links">
          <h2>CUSTOMER SERVICE</h2>
          <Link to="/contact" onClick={toTop}>Contact Us</Link>
          <Link to="/returns" onClick={toTop}>Returns</Link>
          <Link to="/shipping" onClick={toTop}>Shipping Destinations</Link>
          <Link to="/payments" onClick={toTop}>Payments &amp; Billing</Link>
          <Link to="/privacy" onClick={toTop}>Privacy Policy</Link>
          <Link to="/cookies" onClick={toTop}>Cookie Policy</Link>
          <Link to="/accessibility" onClick={toTop}>Accessibility</Link>
          <Link to="/faqs" onClick={toTop}>FAQs</Link>
          <Link to="/terms" onClick={toTop}>Terms & Conditions</Link>
          <Link to="/policies" onClick={toTop}>All Policies</Link>
        </nav>

        <nav aria-label="About footer links">
          <h2>EXPLORE MORE</h2>
          <Link to="/about" onClick={toTop}>Our Story</Link>
          <Link to="/shop?category=Gift+Sets" onClick={toTop}>The Clarity Edit Set</Link>
          <Link to="/shop?category=Notebooks" onClick={toTop}>Notebook Guide</Link>
          <Link to="/shop?category=Planners" onClick={toTop}>Planner Size Guide</Link>
          <Link to="/contact" onClick={toTop}>Concierge</Link>
        </nav>
      </section>

      <div className="footer-payments" aria-label="Supported payment methods">
        <span>SUPPORTED PAYMENT METHODS</span>
        <div><b>VISA</b><b>MASTERCARD</b><b>AMERICAN EXPRESS</b><b>JCB</b><b>UNIONPAY</b></div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} {siteConfig.brandName}. ALL RIGHTS RESERVED.</span>
        <span>DESIGNED FOR INTENTIONAL LIVING.</span>
        <button type="button" onClick={toTop}>BACK TO TOP ↑</button>
      </div>
    </footer>
  );
}

export default Footer;
